import React, { useEffect, createElement } from 'react';
import { SalesHero } from './components/SalesHero';
import { SalesContent } from './components/SalesContent';
import { SalesOffer } from './components/SalesOffer';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
const PIXEL_ID = '1436890408218834';
function initFacebookPixel() {
  if (window.fbq) return;
  const fbq = function (...args: any[]) {
    if ((fbq as any).callMethod) {
      ;
      (fbq as any).callMethod.apply(fbq, args);
    } else {
      ;
      (fbq as any).queue.push(args);
    }
  } as any;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [] as any[];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <div className="min-h-screen font-sans antialiased overflow-x-hidden bg-[#fdfcfa]" data-id="element-0">
      <SalesHero data-id="element-1" />
      <SalesContent data-id="element-2" />
      <SalesOffer data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}